import {observer} from 'mobx-react';
import React, {Component} from 'react';

import {Tabs, Tab} from '@udemy/react-structure-components';

import {TopicContent} from '../topic-content.react-component';
import {TopicListCollectionStore} from '../topic-list-collection.mobx-store';
import '../topic-list-collection.module.less';

const DEFAULT_PAGE_SIZE = 50;

export interface TopicListCollectionDesktopProps {
    store: TopicListCollectionStore;
}

@observer
export class TopicListCollectionDesktop extends Component<TopicListCollectionDesktopProps> {
    componentDidMount() {
        this.props.store.topicTabs[0].store.loadTopics(this.pageSize);
    }

    pageSize: number = DEFAULT_PAGE_SIZE;

    handleSelect = (activeTab: unknown) => {
        this.props.store.topicTabs[activeTab as number].store.loadTopics(this.pageSize);
    };

    render() {
        const tabContent = this.props.store.topicTabs.map((topicTab, i) => {
            return (
                <Tab id={i} key={i} title={topicTab.tabName}>
                    <TopicContent
                        store={this.props.store.topicTabs[i].store}
                        pageSize={this.pageSize}
                    />
                </Tab>
            );
        });
        return (
            <Tabs defaultTabId={0} onSelect={this.handleSelect}>
                {tabContent}
            </Tabs>
        );
    }
}
